/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2023 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2023-11-27
 *
 * ---------------------------------------------------------------------------
 */

import React from 'react';

import { Provider } from 'react-redux';
import { Route, Switch, Router } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import store from '../../store';
import appHistory from '../../appHistory';
import { common } from '../../data/constants';
import Home from '../../scenes/Home';
import Bidding from '../../scenes/BidSession';
import Reports from '../../scenes/Reports';
import History from '../../scenes/History/History';
import Settings from '../../scenes/Settings';
import Impersonate from '../../scenes/Impersonate';
import CrewGroupDefault from '../../scenes/CrewGroupDefault';
import DefaultSettings from '../../scenes/DefaultSettings';
import PastSession from '../../scenes/PastSession';
import { Error500 } from '../ErrorPages';
import ReportLoader from '../../scenes/Reports/components/ReportLoader';
import OIDCMainLayout from '../Layouts/OIDCMainLayout';
import { getLoginRoute } from '../App/helpers';

const customMUI = getMuiTheme({
  palette: {
    primary1Color: common.colors.CI_BLUE,
    primary2Color: common.colors.CI_BLUE,
    pickerHeaderColor: common.colors.CI_BLUE
  }
});

const loginRoute = getLoginRoute();
const OIDCApp = () => (
  <MuiThemeProvider muiTheme={customMUI}>
    <Provider store={store}>
      <Router history={appHistory}>
        <Switch>
          <Route exact path={`${loginRoute.path}`} component={loginRoute.component} />
          <Route exact path="/" component={loginRoute.component} />
          <Route path="/report-loader/:uniqueIdentifier" component={ReportLoader} />
          <OIDCMainLayout>
            <Route exact path="/home" component={Home} />
            <Route path="/bid-session/:bidId" component={Bidding} />
            <Route path="/reports" component={Reports} />
            <Route path="/history" component={History} />
            <Route path="/settings" component={Settings} />
            <Route path="/impersonate" component={Impersonate} />
            <Route path="/crew-group-default" component={CrewGroupDefault} />
            <Route
              path="/help"
              component={() => {
                const hostname = window.location.hostname;
                // eslint-disable-next-line eqeqeq
                // Added for checking localhost application url
                if (hostname !== 'localhost') {
                  window.location.href = window.helpUrl;
                } else {
                  window.location.href = '/assets/help/Content/Home.htm';
                }
                return null;
              }}
            />
            <Route path="/default-settings" component={DefaultSettings} />
            <Route path="/history/:sessionId" component={PastSession} />
            <Route path="/500" component={Error500} />
          </OIDCMainLayout>
        </Switch>
      </Router>
    </Provider>
  </MuiThemeProvider>
);

export default OIDCApp;
